import React, { useRef } from 'react';
import c from 'classnames';

import {
  NavigationScroll,
} from '@uncinc/uncinc-react-kitchen-sink';

import Overlay from './Overlay';
import Header from './Header';

import './style.scss';

const MainMenu = () => {
  const menu = useRef(null);

  const isOverlayOpen = useRef(false);
  const menuButton = useRef(null);
  const lottie = useRef(null);

  const toggleOverlayOpen = (onlyClose = false) => {
    if (!onlyClose || isOverlayOpen.current) {
      lottie.current.play();
    }

    if (onlyClose) {
      isOverlayOpen.current = false;
    } else {
      isOverlayOpen.current = !isOverlayOpen.current;
    }

    menuButton.current.className = isOverlayOpen.current
      ? 'Header__menu hide'
      : 'Header__menu show';

    if (menu.current) {
      menu.current.className = `MainMenu ${isOverlayOpen.current && 'overlay-menu-open'}`;
    }
  };

  const MainMenuClassnames = c(
    'MainMenu',
    { 'overlay-menu-open': isOverlayOpen.current },
  );

  return (
    <NavigationScroll>
      <div
        ref={menu}
        className={MainMenuClassnames}
      >

        <Header
          key="header"
          isOverlayOpen={isOverlayOpen}
          toggleOverlayOpen={toggleOverlayOpen}
          menuButtonRef={menuButton}
          lottieRef={lottie}
        />

        <Overlay toggleOverlayOpen={toggleOverlayOpen} />

      </div>
    </NavigationScroll>
  );
};

export default MainMenu;
